import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { scrollToSection } from "@/lib/scroll";
import { Logo } from "@/components/Logo";

const LINKS = [
  { label: "The Show", id: "show" },
  { label: "The Evening", id: "experience" },
  { label: "Susan", id: "susan" },
  { label: "Seats", id: "seating" },
  { label: "Christmas Gifts", id: "gifting" },
  { label: "Venue", id: "venue" },
  { label: "FAQ", id: "faq" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between gap-4">
        <Link to="/" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} data-testid="navbar-logo">
          <Logo compact={scrolled} />
        </Link>

        <nav className="hidden xl:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => go(e, l.id)}
              className="text-[13px] tracking-wide text-[#C5CEE0] hover:text-[#F3D068] transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={(e) => go(e, "seating")}
            data-testid="navbar-select-seats-cta"
            className="btn-gold hidden sm:inline-flex rounded-full px-6 py-2.5 text-sm font-semibold whitespace-nowrap"
          >
            Reserve Tickets
          </button>
          <button
            className="p-2 text-[#F3D068] inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="navbar-menu-toggle"
          >
            <span className="hidden sm:inline">Menu</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
              {open ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M3 7h18M3 12h18M3 17h18" />}
            </svg>
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden glass mt-3 mx-4 rounded-2xl p-5 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => go(e, l.id)}
              className="text-[#C5CEE0] hover:text-[#F3D068] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={(e) => go(e, "seating")}
            data-testid="navbar-select-seats-cta-mobile"
            className="btn-gold rounded-full px-6 py-3 text-sm font-semibold"
          >
            Reserve Tickets
          </button>
        </div>
      )}
    </header>
  );
};

export default Nav;
